module.exports = __webpack_public_path__ + "static/media/earthi.d54560c4.svg";